import { createSelector } from 'reselect'

const select = (state) => state.suggested

const selectSuggested = createSelector(
  select,
  (suggested) => suggested.suggested
)

const selectIsFetching = createSelector(
  select,
  (suggested) => suggested.isFetching
)

const selectTutorials = createSelector(selectSuggested, (suggested) =>
  suggested.filter((item) => item.object_type === 'tutorial')
)

const selectFaqs = createSelector(selectSuggested, (suggested) =>
  suggested.filter((item) => item.object_type === 'faq')
)

export { selectSuggested, selectIsFetching, selectTutorials, selectFaqs }
